import React from 'react';
//import PropTypes from 'prop-types';

// @material-ui
import { Button } from '@material-ui/core';

// core
import { getValue, setValue } from '_core/utils/storage';
import { useGlobal } from '_core/hooks/useGlobal';
import { withLang } from '_core/hocs/withLang';
import { ModalInner } from '_core/components/ModalInner';
import { ModalOuter } from '_core/components/ModalOuter';
import { ArticleContainer } from '_core/components/ArticleContainer';


const RawGreetingsSplash = (props) => {
  const {
    path,
    getLangString: l
  } = props;
  
  const {
    request: { queue },
    config: {
      API_METHOD,
      COOKIES_KEY
    }
  } = useGlobal();
  
  const [isOpen, setIsOpen] = React.useState();
  const [article, setArticle] = React.useState();
  
  if (path && isOpen === undefined) {
    setIsOpen(false);
    
    if (getValue(COOKIES_KEY.SPLASH) !== 1) {
      setTimeout(() => {
        queue(API_METHOD.ARTICLE_INFO, { path })
          .then((data) => { setArticle(data); setValue(COOKIES_KEY.SPLASH, 1); setIsOpen(true); })
          .catch((error) => console.error(error));
      }, 500);
    }
  }
  
  return (
    <ModalOuter closeIcon open={isOpen} onClose={(event) => setIsOpen(false)}>
      <ModalInner
        title={article?.title}
        content={
          <ArticleContainer variant="body1">
            {article?.content}
          </ArticleContainer>
        }
        actions={
          <Button onClick={(event) => setIsOpen(false)}>
            {l('r._.splash.greetings.control.ok')}
          </Button>
        }
      />
    </ModalOuter>
  );
};

RawGreetingsSplash.defaultProps = {};

RawGreetingsSplash.propTypes = {};

export const GreetingsSplash = withLang(RawGreetingsSplash);
